module.exports = __webpack_public_path__ + "static/images/redirect.2itoOcA.svg";